import styled from "styled-components";

interface ScanningWarningBannerStyledProps {
  isError?: boolean;
}

const ScanningWarningBannerStyled = styled.div<ScanningWarningBannerStyledProps>`
  background-color: ${({ theme, isError }) =>
    isError ? theme.colors.primary1opacity90 : "transparent"};
  border-radius: ${({ theme }) => theme.borderRadiusBanner};
  color: ${({ theme, isError }) =>
    isError ? theme.colors.baseWhite : theme.colors.primary1};
  padding: 12px 16px;
  display: flex;
  gap: 8px;

  img {
    width: 22px;
    height: 22px;
  }
`;

export default ScanningWarningBannerStyled;
